// Panel shortcuts: Cmd/Ctrl+J toggles the panel, Cmd/Ctrl+Shift+O starts a new chat.

export function isMac(): boolean {
  if (typeof navigator === 'undefined') return false;
  return /Mac|iPhone|iPad|iPod/.test(navigator.platform || navigator.userAgent);
}

/** "⌘" on Apple devices, "Ctrl+" elsewhere, for tooltips. */
export function modKey(): string {
  return isMac() ? '⌘' : 'Ctrl+';
}

type KeyLike = Pick<KeyboardEvent, 'key' | 'metaKey' | 'ctrlKey' | 'shiftKey' | 'altKey'>;

const mod = (e: KeyLike) => e.metaKey || e.ctrlKey;

export function isTogglePanelShortcut(e: KeyLike): boolean {
  return mod(e) && !e.shiftKey && !e.altKey && e.key.toLowerCase() === 'j';
}

export function isNewChatShortcut(e: KeyLike): boolean {
  return mod(e) && e.shiftKey && !e.altKey && e.key.toLowerCase() === 'o';
}
